import { Theme } from '@mui/material';
import * as Types from 'types/types';

export type SortField = 'name' | 'date' | 'size' | 'type' | 'rag';
export type SortDirection = 'asc' | 'desc';

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const getFileTypeColor = (theme: Theme, type: string): string => {
  switch (type) {
    case 'pdf':
      return theme.palette.primary.main;
    case 'docx':
      return theme.palette.secondary.main;
    case 'txt':
      return theme.palette.success.main;
    case 'md':
      return theme.palette.warning.main;
    default:
      return theme.palette.primary.main;
  }
};

function getDocumentSortValue(doc: Types.Document, sortField: SortField): string | number | null {
  switch (sortField) {
    case 'name':
      return doc.filename.toLowerCase();
    case 'date':
      return (doc.updatedAt || doc.uploadDate)?.getTime() || 0;
    case 'size':
      return doc.size;
    case 'type':
      return doc.type.toLowerCase();
    case 'rag':
      return doc.options?.includeInRag ? 1 : 0;
    default:
      return null;
  }
}

export function compareDocuments(
  a: Types.Document,
  b: Types.Document,
  sortField: SortField,
  sortDirection: SortDirection
): number {
  const aValue = getDocumentSortValue(a, sortField);
  const bValue = getDocumentSortValue(b, sortField);
  if (aValue === null || bValue === null) return 0;
  if (aValue < bValue) return sortDirection === 'asc' ? -1 : 1;
  if (aValue > bValue) return sortDirection === 'asc' ? 1 : -1;
  return 0;
}
